/**
 * API Configuration for Admin App
 */

import { createApiClient, ApiClient } from '@raffle/api-client';

// API base URL - use environment variable or default to local
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

// Token management
let accessToken: string | null = null;
let refreshToken: string | null = null;

export function getAccessToken(): string | null {
  if (!accessToken) {
    accessToken = localStorage.getItem('admin_access_token');
  }
  return accessToken;
}

export function getRefreshToken(): string | null {
  if (!refreshToken) {
    refreshToken = localStorage.getItem('admin_refresh_token');
  }
  return refreshToken;
}

export function setTokens(tokens: { accessToken: string; refreshToken: string }) {
  accessToken = tokens.accessToken;
  refreshToken = tokens.refreshToken;
  localStorage.setItem('admin_access_token', tokens.accessToken);
  localStorage.setItem('admin_refresh_token', tokens.refreshToken);
}

export function clearTokens() {
  accessToken = null;
  refreshToken = null;
  localStorage.removeItem('admin_access_token');
  localStorage.removeItem('admin_refresh_token');
  localStorage.removeItem('admin_user');
}

// Create API client instance
export const api: ApiClient = createApiClient({
  baseUrl: API_BASE_URL,
  getAccessToken,
  onTokenExpired: async () => {
    const refresh = getRefreshToken();
    if (refresh) {
      try {
        const result = await api.auth.refresh(refresh);
        if (result.success && result.data) {
          setTokens({
            accessToken: result.data.tokens.accessToken,
            refreshToken: result.data.tokens.refreshToken,
          });
          return;
        }
      } catch {
        // Refresh failed
      }
    }
    clearTokens();
    window.location.href = '/login';
  },
  onUnauthorized: () => {
    clearTokens();
    window.location.href = '/login';
  },
});

export { API_BASE_URL };
